import { type OpenApiSchemaIntegrationType } from '../../api/schema';
import { OZON_SERVICE_NAME } from '../brand';
import { isSupportedIntegrationType } from './isSupportedIntegrationType';
import { type SupportedIntegrationTypes } from './types';

const UNKNOWN = 'Неизвестно';
const DISPLAY_TYPE: Record<SupportedIntegrationTypes, string> = {
    '1C': '1C',
    wildberries: 'Wildberries',
    ozon: OZON_SERVICE_NAME,
    ozon_fbo_plus: `${OZON_SERVICE_NAME} Доставка (FBO)`,
    ozon_delivery_fbs: `${OZON_SERVICE_NAME} Доставка (FBS)`,
    yandex_market: 'Яндекс Маркет',
    ya_market_laas: 'Фулфилмент Яндекс Маркета',
    moysklad: 'МойСклад',
    yml: 'YML-фид',
} as const;

export const getDisplayTypeFromType = (type?: OpenApiSchemaIntegrationType) =>
    type && isSupportedIntegrationType(type) ? DISPLAY_TYPE[type] : UNKNOWN;
